// noinspection DuplicatedCode

import {createGrid} from "../../../helpers/grids/grids";
import createElement from "../../../helpers/createElement";
import Axios from "axios";
import {handleAjaxSuccess, swalConfirm} from "../../../helpers/swalHelper";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../../helpers/loading";
import {createCellRenderer, createDoubleClickHandler} from "../../../helpers/grids/helpers";
import {getSingleInputByNameV3} from "../../../helpers/forms/formInputsHelpers";
import {ServerModalV3} from "../../../helpers/modals/ClassBased/ServerModalV3";
import {initSwiper} from "../../../helpers/swiper/swiper";

/**
 * Shared by cast and crew index views
 */
function initProductionAuditionRequestsIndex() {
	const typeSelect = document.querySelector('.type-select');
	const roleSelect = document.querySelector('.role-select');

	// noinspection JSValidateTypes
	/** @var {AuditionsDefs.AuditionViewType} */
	const viewType = getSingleInputByNameV3(document.body, 'audition_view_type');

	let paginationPageSize = 200;
	let cacheBlockSize = 400;

	// Use column auto height by default
	let getRowHeightHandler = undefined;

	if (viewType === 'cast-headshots') {
		paginationPageSize = 500;
		cacheBlockSize = 100;

		getRowHeightHandler = () => {
			return 180;
		}
	}

	const grid = createGrid('.audition-requests-grid', {
			columnDefs: getColumnDefinitions(),
			paginationPageSize,
			cacheBlockSize,
			paginationPageSizeSelector: [100, 500],

			_rowName: 'Requests',
			rowClass: 'cursor-pointer',
			onRowDoubleClicked: createDoubleClickHandler(data => {
				if (viewType === 'cast-headshots') {
					// Display headshot modal
					displayActorPictureModal(data);
				} else {
					// Default behavior for all index views
					// loading();
					// noinspection JSUnresolvedVariable
					window.open(data.view_url, '_blank');
					// window.location.href = data.view_url;
				}
			}),
			getRowHeight: getRowHeightHandler,
		},
		window['routes/admin.productions.audition-requests.grid'],
		() => {
			return {
				type: typeSelect ? typeSelect.value : undefined,
				role: roleSelect ? roleSelect.value : undefined,
			}
		}
	);

	if (typeSelect) {
		typeSelect.addEventListener('change', () => {
			grid._refresh();
		})
	}
	if (roleSelect) {
		roleSelect.addEventListener('change', () => {
			grid._refresh();
		})
	}


	/** Methods */

	function removeRequest(request) {
		swalConfirm({
			title: 'Are you sure you want to delete this request?'
		}).then(response => {
			if (response.isConfirmed) {
				loading();

				// noinspection JSUnresolvedVariable
				Axios.post(request.remove_url)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		})
	}

	/**
	 * We put this in a separate function so we can easily define empty
	 * columns and then remove them before giving them to ag grid
	 *
	 * @return {import('ag-grid-community/dist/lib/entities/colDef').ColDef[]}
	 */
	function getColumnDefinitions() {
		// Custom handling for crew headshots view
		if (viewType === 'cast-headshots') {
			return getColumnDefinitionsForCrewHeadshots();
		}

		// Default handling for auditions views
		const columns = [
			{
				field: "full_name",
				headerName: 'Name',
				sortable: true,
				pinned: 'left',
				cellRenderer: createCellRenderer(params => {
					/** @var {Object<string,any>} */
					const request = params.data;
					const warningsString = getWarningHtml(request);

					const requestedRolesString = request.roles_string;
					const castRolesString = request.cast_roles_string;

					const rolesStringToDisplay = castRolesString === 'NONE' ?
						// Display requested roles
						`Requested Roles: ${requestedRolesString}` :
						// Display cast roles
						`Cast As: ${castRolesString}`

					if (viewType === 'all') {
						// noinspection JSUnresolvedReference
						if (request.audition_type === 'cast') {
							return createElement(`
								<div style="line-height: 1">
									<div>
										${params.data.full_name}
										${warningsString}
									</div>
									<div class="small text-muted text-wrap py-1" title="Audition Type">${request.crew_type_string}</div>
									<div class="small text-muted text-wrap pb-1" title="Roles">${rolesStringToDisplay}</div>
								</div>
							`);
						} else {
							return createElement(`
								<div style="line-height: 1">
									<div>
										${params.data.full_name}
										${warningsString}
									</div>
									<div class="small text-muted text-wrap py-1" title="Audition Type">${request.crew_type_string}</div>
								</div>
							`);
						}
					} else if (viewType === 'cast' || viewType === 'virtual-cast') {
						// noinspection JSUnresolvedReference
						return createElement(`
							<div style="line-height: 1">
								<div>
									${params.data.full_name}
									${warningsString}
								</div>
								<div class="small text-muted text-wrap py-1" title="Roles">${rolesStringToDisplay}</div>
							</div>
						`);
					} else {
						// noinspection JSUnresolvedReference
						return params.data.full_name;
					}
				}),
				minWidth: 200,
				maxWidth: 210,
				suppressAutoSize: true,
				autoHeight: true,

			},
			{
				field: "email",
				headerName: 'Email',
				sortable: true,
			},
			{
				field: "submitted_at",
				headerName: "Submitted At",
				sortable: true,
				sort: 'desc',
			},
			viewType === 'cast' ?
				{
					field: "audition_date",
					headerName: "Audition Date",
					sortable: false,

				} : undefined,
			viewType === 'crew' ?
				{
					field: "crew_type_string",
					headerName: "Type",
					sortable: false,
				} : undefined,
			viewType === 'virtual-cast' ?
				{
					field: "virtual_audition_link",
					headerName: "Video Submitted",
					sortable: false,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedReference
						if (params.data.virtual_audition_link) {
							// noinspection JSUnresolvedReference
							return createElement(
								`
										<div>
											<a href="${params.data.virtual_audition_link}" title="View Submission" title="View Submission">
												Yes <i class="fa-solid fa-arrow-up-right-from-square"></i
											></a
										></div>
									`
							)
						} else {
							return createElement(`<div class="text-muted">No</div>`)
						}
					})
				} : undefined,
			{
				field: "public_id",
				headerName: '',
				maxWidth: 270,
				cellRenderer: createCellRenderer(params => {
					// noinspection JSUnresolvedVariable
					const buttons = createElement(`
                            <div class="buttons">
                            	<a class="btn btn-primary btn-sm ${!params.data.can_view ? 'd-none' : ''}" href="${params.data.view_url}" target="_blank">
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                    View
								</a>
								<a class="btn btn-info btn-sm ${!params.data.can_edit ? 'd-none' : ''}" href="${params.data.edit_url}" target="_blank">
                                    <i class="fa-solid fa-pen"></i>
                                    Edit
								</a>
                                <button type="button" class="btn btn-danger btn-sm ${!params.data.can_delete ? 'd-none' : ''} remove-audition-request-button">
                                    <i class="fa-solid fa-trash"></i>
                                    Delete
                                </button>
                            </div>`
					)

					const deleteButton = buttons.querySelector('.remove-audition-request-button');

					deleteButton.onclick =
						() => removeRequest(params.data);

					return buttons;
				})
			},
		];

		// Filter non defined columns
		return columns.filter(column => column);
	}

	/**
	 *
	 * @return {import('ag-grid-community/dist/lib/entities/colDef').ColDef[]}
	 */
	function getColumnDefinitionsForCrewHeadshots() {
		return [
			{
				field: "public_id",
				headerName: 'Picture',
				maxWidth: 130,
				minWidth: 120,
				cellClass: 'fill-space',
				cellRenderer: createCellRenderer(params => {
					return getPhotoCellElement(params.data);
				})
			},
			{
				field: "full_name",
				headerName: 'Name',
				sortable: true,
				sort: 'asc',
				cellRenderer: createCellRenderer(params => {
					return `<span style="font-size: 1.2rem">${params.data.full_name}</span>`;
				})
			},
		];
	}

	/**
	 * Returns a warning icon if required
	 * @return {string}
	 */
	function getWarningHtml(auditionRequest) {
		const warnings = [];

		// noinspection JSUnresolvedReference
		if (!auditionRequest.date_of_birth) {
			// If audition date of birth is missing
			warnings.push('Date of birth missing')
		}

		if (warnings.length === 0) {
			// No warnings
			return '';
		}

		// Build warning icon
		const warningsString = warnings.join('\n');

		return `<i class="fa-solid fa-circle-exclamation red-error-font" title="${warningsString}"></i>`
	}

	function getPhotoCellElement(actor) {
		// noinspection HtmlRequiredAltAttribute,JSUnresolvedReference
		const html = `
			<div class="photo-cell h-100 d-flex justify-content-center align-items-center">
				<div class="position-relative" style="width: 120px; height: 160px">
					<div class="photo-wrapper border">
						${actor.photo_thumbnail ? `<img src="${actor.photo_thumbnail}" loading="lazy">` : `<div class="text-muted text-center no-photo-message">No<br>Photo</div>`}
					</div>
				</div>
			</div>
		`;

		const cell = createElement(html);

		cell.querySelector('.photo-wrapper').addEventListener('click', () => {
			displayActorPictureModal(actor)
		})

		return cell;
	}

	function displayActorPictureModal(actor) {
		// TODO: Refactor into a an actual class
		// noinspection JSUnresolvedReference
		new ServerModalV3(
			actor.actor_headshot_modal_url,
			{
				init(modal) {
					const swiperContainer = modal.modalContainer.querySelector('.swiper');

					initSwiper(
						swiperContainer,
						{},
						modal
					);
				}
			}
		);
	}
}

export {
	initProductionAuditionRequestsIndex
}
